/**
 * Created by danielr on 2/27/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/twilio/twilioConfigView.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var StepIndicator = require("ui/stepIndicator/StepIndicator");
    var Bubble = require("ui/bubble/Bubble");

    var TwilioConfigView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        TwilioConfigView = Marionette.ItemView.extend({
            template : template,
            className : "conversation-source-edit-config-container twilio-config-container",
            ui : {
                cancelButton: ".button-cancel",
                backButton: ".button-back",
                nextButton: ".button-next",
                doneButton: ".button-done",
                sidContainer: ".sid-container",
                tokenContainer: ".token-container",
                phoneContainer: ".phone-container",
                phoneInfo: ".icon",
                progressBar: ".conversation-source-edit-progress-bar"
            },
            uiComponents : {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelClick"
                    }
                },
                backButton:{
                    type: Button,
                    options: {
                        el: "view.ui.backButton",
                        permutation: Button.PERMUTATION.BTN
                    },
                    events: {
                        "click": "_onBackClick"
                    }
                },
                nextButton: {
                    type: Button,
                    options: {
                        el: "view.ui.nextButton",
                        disabled: true,
                        initState: Button.STATES.DISABLED,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    }
                },
                doneButton: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        initState:"view._getDoneButtonState"
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                },
                sid: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.B,
                        el: "view.ui.sidContainer",
                        value: "view._getSid"
                    },
                    events: {
                        change: "_onSidChange"
                    }
                },
                token: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.B,
                        el: "view.ui.tokenContainer",
                        value: "view._getToken"
                    },
                    events: {
                        change: "_onTokenChange"
                    }
                },
                phone: {
                    type: InputField,
                    options: {
                        permutation: InputField.Permutation.B,
                        el: "view.ui.phoneContainer",
                        value: "view._getPhone",
                        placeholder: "+12345678910"
                    },
                    events: {
                        change: "_onPhoneChange"
                    }
                },
                progressBar: {
                    type: StepIndicator,
                    options: {
                        el: "view.ui.progressBar",
                        permutation: StepIndicator.PERMUTATION.G,
                        steps: [
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.stepName"), state: "view._getActivationStepComplete"},
                            { text: LE.translator.translate("LEManager.dataSources.conversationSources.general.config.stepName"), state: StepIndicator.STATE.CURRENT}
                        ]
                    }
                }
            },
            events: {
                "mouseenter @ui.phoneInfo": "_showPhoneBubble",
                "mouseleave @ui.phoneInfo": "_closePhoneBubble"
            },
            modelEvents: {
                "change": "_onModelChange"
            },
            initialize : function (options) {
                LEManager.logger.debug("TwilioConfigView:initialize");
                this.channel = LEManager.media.channel("conversationSources");
                this._bindEvents();
            },
            _bindEvents: function(){
                this.listenTo(this, "page:closeButtonClick", this._onCancelClick);
            },
            _getSid: function(){
                return this.model.getAccountSid();
            },
            _onSidChange: function(componentId, eventName, value){
                this.model.setAccountSid(value);
            },
            _getToken: function(){
                return this.model.getAuthToken();
            },
            _onTokenChange: function(componentId, eventName, value){
                this.model.setAuthToken(value);
            },
            _getPhone: function(){
                return this.model.getPhone();
            },
            _onPhoneChange: function(componentId, eventName, value){
                this.model.setPhone(value);
            },
            _onModelChange: function(){
                var doneButtonState = this._getDoneButtonState();
                this.uiComponents.doneButton.setState(doneButtonState);
            },
            _hideErrors: function () {
                this.uiComponents.sid.setError(false);
                this.uiComponents.token.setError(false);
                this.uiComponents.phone.setError(false);
            },
            _onDoneClick: function(){
                this._hideErrors();
                var errors = this.model.validate();
                if (!_.isEmpty(errors)){
                    this._setErrors(errors);
                }
                else {
                    this.channel.trigger("twilio:config:done");
                }
            },
            _setErrors: function (errors) {
                if (_.has(errors, this.model.KEYS.ACCOUNT_SID)) {//todo missing error translation - can see it with the phone
                    this.uiComponents.sid.setError(true, LE.translator.translate(errors[this.model.KEYS.ACCOUNT_SID]));
                }
                if (_.has(errors, this.model.KEYS.AUTH_TOKEN)) {
                    this.uiComponents.token.setError(true, LE.translator.translate(errors[this.model.KEYS.AUTH_TOKEN]));
                }
                if (_.has(errors, this.model.KEYS.PHONE)) {
                    this.uiComponents.phone.setError(true, LE.translator.translate(errors[this.model.KEYS.PHONE]));
                }
            },
            _onCancelClick: function(){
                this.channel.trigger("twilio:config:cancel");
            },
            _onBackClick: function(){
                this.channel.trigger("twilio:config:back");
            },
            _getDoneButtonState: function(){
                return this.model.validateSaveEnabled() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },
            _getActivationStepComplete: function(){
                ///TODO after we get real api
                return StepIndicator.STATE.COMPLETED;
            },
            _showPhoneBubble: function() {
                this._closePhoneBubble(null, true);
                this.uiComponents.host$.createAndRender("phoneBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.phoneInfo,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate("LEManager.dataSources.conversationSources.twilio.config.details.phone.tooltip")
                    }
                });
            },
            _closePhoneBubble: function(event, force) {
                if (this.uiComponents.phoneBubble) {
                    this.uiComponents.phoneBubble.close(force);
                }
            },
            onClose : function () {
                LEManager.logger.debug("TwilioConfigView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return TwilioConfigView;
});
